import { render } from "./SocialPostDropzone.vue?vue&type=template&id=36a01252"
import script from "./SocialPostDropzone.vue?vue&type=script&lang=js"
export * from "./SocialPostDropzone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__